<template>
  <v-menu
    v-model="isMenuOpen"
    :close-on-content-click="false"
    :disabled="disabled"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value"
        :label="label"
        :class="inputClass"
        :prepend-icon="prependIcon"
        :name="name"
        :rules="required ? rules.required : []"
        :error-messages="errorMessages"
        :disabled="disabled"
        :hide-details="hideDetails"
        :clearable="clearable"
        required
        readonly
        v-on="on"
        @input="$emit('input', $event)"
      />
    </template>
    <v-date-picker
      :value="value"
      :min="min || undefined"
      :max="max || undefined"
      :locale="$t('general.locale')"
      color="primary"
      @input="onPick"
    />
  </v-menu>
</template>

<script>
/**
 * Campo de fecha reutilizable: encapsula el par v-menu + v-date-picker que se
 * repetía en cada formulario de solicitudes, conservando el marcado original.
 */
export default {
  name: 'DateField',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    prependIcon: {
      type: String,
      default: 'event'
    },
    /** Se propaga al input real para poder identificarlo desde la vista. */
    name: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: 'pt-2 mt-0'
    }
  },
  data () {
    return {
      isMenuOpen: false
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    }
  },
  methods: {
    onPick (date) {
      this.isMenuOpen = false
      this.$emit('input', date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requests/DateField.vue